import React from 'react';
import { string, bool, oneOf } from 'prop-types';
import cx from 'classnames';

const CLASS_ROOT = 'img';

const propTypes = {
  alt: string,
  src: string.isRequired,
  isFluid: bool,
  width: oneOf([
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'xxlarge',
  ]),
  widthAttr: string,
  height: oneOf([
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'xxlarge',
  ]),
  heightAttr: string,
};

const Image = ({
  className,
  alt = '',
  src,
  isFluid,
  width,
  widthAttr,
  height,
  heightAttr,
  ...other
}) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--fluid`]: isFluid,
      [`${CLASS_ROOT}--${width}-w`]: width && typeof width === 'string',
      [`${CLASS_ROOT}--${height}-h`]: height && typeof height === 'string',
    },
    className,
  );

  return <img className={classes} alt={alt} src={src} {...other} />;
};

Image.propTypes = propTypes;

export default Image;
